export enum TextStyle {
  DEFAULT,
  HIGHLIGHTED,
}

type TextStylesConfiguration = {
  styles: TextStyle[];
  tag: String[];
};

type StyledTextToken = {
  token: string;
  style: TextStyle;
};

const DEFAULT_ALT_STYLE_CONFIGS: TextStylesConfiguration = {
  styles: [TextStyle.DEFAULT, TextStyle.HIGHLIGHTED],
  tag: ["%", "%"],
};

/**
 * Creates an array of text tokens with a bound style reference
 * @param inText - the text to tokenize
 * @param configs - the configurations
 * @returns - an array of text tokens with a bound style reference
 */
export function getStyledTextTokens(inText: string, configs: TextStylesConfiguration = DEFAULT_ALT_STYLE_CONFIGS): StyledTextToken[] {
  let tagHead: number = 0;
  let styleHead: number = 0;
  let isEscaping: boolean = false;
  let tokens: StyledTextToken[] = [];
  let token: string = "";
  let ambiguousChunk: string = "";
  for (let head: number = 0; head < inText.length; head++) {
    const charAt: string = inText[head];
    if (charAt === configs.tag[tagHead]) {
      if (isEscaping) {
        isEscaping = false;
        token += charAt;
      } else if (++tagHead >= configs.tag.length) {
        tagHead = 0;
        if (token.length > 0) {
          tokens.push({
            token: token,
            style: configs.styles[styleHead % configs.styles.length],
          });
        }
        token = "";
        ambiguousChunk = "";
        styleHead++;
      } else {
        ambiguousChunk += charAt;
        if (head === inText.length - 1) {
          token += ambiguousChunk;
        }
      }
    } else {
      tagHead = 0;
      token += ambiguousChunk + charAt;
      ambiguousChunk = "";
    }
  }

  if (token.length > 0) {
    tokens.push({
      token: token,
      style: configs.styles[styleHead++ % configs.styles.length],
    });
  }
  return tokens;
}

export const nameRegex = /^[a-zA-ZàèéìòùÀÈÉÌÒÙäëïöüÄËÏÖÜâêîôûÂÊÎÔÛñÑçÇ\s\-\u2013\u2014]+$/;
export const mailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const phoneRegex = /^[\d](?:[\s]*\d){0,9}$/;
// export const noEmptySpacesRegex = /[^-s]/;
export const noEmptySpacesRegex = /^\S*$/;
